import React, { useState, useEffect, useCallback } from 'react'
import { Button, Modal, Toast } from '@ow/comps'
import { pick, get } from 'lodash-es'
import { IconMaps } from '@ow/icons'
import useProjectStore from '@vt/hooks/lib/project/use-project-store'
import { DateRangePicker } from '@mantine/dates'
import { Radio, Tooltip, Select } from '@mantine/core'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import {
  exportDownloadBigTable,
  exportDownloadLogInfo,
  easyDownloadUrl,
} from '@vt/apis/lib-ex/v2/givrali'

const Exporter = function ({ children }) {
  const { appId } = useAppEx()
  const { getToken } = useProjectStore((s) => pick(s, ['getToken']))
  const token = getToken()
  const [isDisable, setIsDisable] = useState(false)
  const [type, setType] = useState('all') // 导出类型
  const [isOpen, setIsOpen] = useState('是') // 是否展开
  const [standardIds, setStandardIds] = useState([])
  const [standardId, setStandardId] = useState([])
  const [value, setValue] = useState([new Date(), new Date()])
  const { tbId, filters, exporterConfig, selectedIds } = useTbViewStore(
    (state) => pick(state, ['tbId', 'filters', 'exporterConfig', 'selectedIds'])
  )
  const { getDitto } = useAppEx((state) => pick(state, ['getDitto']))
  const options = []
  const exporterAll = get(exporterConfig, 'exporterAll', false)
  const exporterFilters = get(exporterConfig, 'exporterFilters', false)
  const exporterChecked = get(exporterConfig, 'exporterChecked', false)
  const exporterLoginfo = get(exporterConfig, 'exporterLoginfo', false) // 导出全部修改记录
  const exporterFiltersLoginfo = get(
    exporterConfig,
    'exporterFiltersLoginfo',
    false
  ) // 导出筛选条件下修改记录
  const onlyLastArea = get(exporterConfig, 'onlyLastArea', false) // 是否只显示末级点位标题
  if (exporterAll) {
    options.push({ label: '导出全部（Excel）', value: 'all' })
  }
  if (exporterFilters) {
    options.push({
      label: '导出筛选条件下的数据（Excel）',
      value: 'filters',
      defaultChecked: true,
    })
  }
  if (exporterLoginfo) {
    options.push({
      label: '导出修改记录（Excel）',
      value: 'loginfo',
    })
  }
  if (exporterChecked && selectedIds.length) {
    options.push({
      label: '导出选中的数据（Excel）',
      value: 'checked',
      disabled: !selectedIds.length,
    })
  }
  if (exporterFiltersLoginfo) {
    options.push({
      label: '导出筛选条件下数据的修改记录（Excel）',
      value: 'filtersLoginfo',
    })
  }
  const openOpt = [
    {
      label: '是',
      value: '是',
      tooltip: '大表表头包含指标盒字段选项，结果以选项赋分值展示',
    },
    {
      label: '否',
      value: '否',
      tooltip: '大表表头只包含指标，结果以选项内容展示',
    },
  ]
  const fetchData = async () => {
    const data = await getDitto('standard').fetchTbData({ pageSize: 10000 })
    const newStandard = []
    data.forEach((v) => {
      if (v.level === 1) {
        newStandard.push(v.objectId)
      }
    })
    const standardTbid = await getDitto('standard').tbId
    setStandardId(standardTbid)
    setStandardIds(newStandard)
  }

  useEffect(() => {
    fetchData()
  }, [])
  const exportAllFn = () => {
    const startTime = value[0].getTime()
    const endTime = value[1].getTime() + 86399999
    setIsDisable(true)
    const query = {
      onlyLastArea,
      startTime,
      endTime,
    }
    if (type === 'filtersLoginfo' || type === 'loginfo') {
      exportDownloadLogInfo(
        appId,
        tbId,
        type === 'all' ? {} : filters,
        type === 'all' ? { size: 10000 } : {},
        query
      )
        .then((res) => {
          setIsDisable(false)
          window.open(easyDownloadUrl(appId, res, token))
        })
        .catch(() => {
          Toast.error({ title: '导出失败' })
          setIsDisable(false)
        })
    } else {
      exportDownloadBigTable(
        appId,
        standardIds.join(','),
        tbId,
        standardId,
        type === 'all' ? {} : filters,
        isOpen === '是',
        type === 'all'
          ? {
              size: 10000,
              order: { desc: false, slug: 'handCreatedAt' },
            }
          : {
              order: { desc: false, slug: 'handCreatedAt' },
            }
      ).then((res) => {
        setIsDisable(false)
        window.open(res.ossUrl)
      })
    }
  }

  const FooterComp = useCallback(
    ({ close }) => (
      <div className="flex">
        <Button
          className="mr-2"
          type="secondary"
          opacityType="sm"
          onClick={() => {
            close()
          }}
        >
          取消
        </Button>
        <Button
          className="mr-2"
          type="primary"
          disabled={isDisable}
          onClick={() => {
            exportAllFn()
            close()
          }}
        >
          导出
        </Button>
      </div>
    ),
    [isDisable, filters, isOpen, type, standardIds, standardId, value]
  )
  return (
    <Modal
      nested
      size="sm"
      title="导出问题大表"
      trigger={children}
      showCloseButton
      closeOnDocumentClick={false}
      footer={FooterComp}
    >
      <>
        <div style={{ fontSize: '14px', fontWeight: 500, color: '#212529' }}>
          请选择导出内容：
        </div>
        <Select
          className="mt-4"
          data={options}
          value={type}
          style={{ width: '100%' }}
          onChange={setType}
        />
        {type === 'filtersLoginfo' || type === 'loginfo' ? (
          <div className="mt-6">
            <div
              className="mb-4"
              style={{ fontSize: '14px', fontWeight: 500, color: '#212529' }}
            >
              请选择修改时间：
            </div>
            <DateRangePicker
              styles={() => ({
                monthPickerControlActive: {
                  background: `rgb(var(--ow-primary-color))!important`,
                },
                yearPickerControlActive: {
                  background: `rgb(var(--ow-primary-color))!important`,
                },
              })}
              allowSingleDateInRange
              locale="zh-cn"
              inputFormat="YYYY/MM/DD"
              placeholder="开始时间 - 结束时间"
              value={value}
              clearable={false}
              onChange={setValue}
            />
            <div className="mt-2" style={{ color: 'red', fontSize: '12px' }}>
              *最多导出1000条数据的修改记录
            </div>
          </div>
        ) : (
          <Radio.Group
            orientation="vertical"
            label="表头是否展开字段："
            value={isOpen}
            style={{ marginTop: '20px' }}
            onChange={setIsOpen}
          >
            {openOpt.map((v, index) => {
              return (
                <div className="flex" key={`openOpt-${index}`}>
                  <Radio value={v.value} label={v.label} />
                  <Tooltip
                    label={v.tooltip}
                    position="right"
                    color="blue"
                    withArrow
                  >
                    <div className="cursor-pointer ml-2">
                      <IconMaps
                        type="questionIcon"
                        fill="#181818"
                        width={20}
                        height={20}
                      />
                    </div>
                  </Tooltip>
                </div>
              )
            })}
          </Radio.Group>
        )}
      </>
    </Modal>
  )
}
export default Exporter
